<template>
  <div class="rounded-borders-lg q-pa-md bg-white">
    <div class="row q-gutter-x-md">
      <img
        v-if="img"
        :src="img"
        alt="vehicle"
        class="col-xs-5 col-sm-5 col-md-4 col-lg-4 vehicle-image"
      />
      <div class="column col">
        <div>
          <QBtn
            class="q-mb-sm"
            padding="4px 12px"
            dense
            disable
            :ripple="false"
            v-if="orderNumber"
            @click="$emit('open:document', orderNumber)"
          >
            <QIcon
              color="primary"
              name="eva-file-text-outline"
              class="q-mr-sm"
            />
            <span class="word-break-word">#{{ orderNumber }}</span>
          </QBtn>
        </div>
        <div v-if="!isMobile" class="text-capitalize">
          <p
            v-if="vehicleTitle"
            class="text-weight-medium q-mt-sm text-application-primary"
          >
            {{ vehicleTitle }}
          </p>
          <p
            v-if="vehicleSubTitle"
            class="text-weight-regular text-label q-mt-sm text-application-primary"
          >
            {{ vehicleSubTitle }}
          </p>
        </div>
      </div>
    </div>
    <div class="text-center q-mt-md text-capitalize" v-if="isMobile">
      <p
        v-if="vehicleTitle"
        class="text-weight-medium text-application-primary text-title"
      >
        {{ vehicleTitle }}
      </p>
      <p
        v-if="vehicleSubTitle"
        class="text-weight-regular text-label q-mt-sm text-application-primary"
      >
        {{ vehicleSubTitle }}
      </p>
    </div>
  </div>
</template>

<script>
import { QBtn, QIcon } from 'quasar';

export default {
  name: 'SettlementDetailsCard',
  props: {
    isMobile: Boolean,
    img: String,
    orderNumber: String,
    vehicleTitle: String,
    vehicleSubTitle: String,
    vin: String,
    rego: String
  },
  components: {
    QBtn,
    QIcon
  }
};
</script>

<style lang="sass" scoped>
.vehicle-image
  object-fit: contain
  object-position: top
</style>
